import restApi from "../../http.js";
import session from "../session";

export default class UserApi {
  getBulletinPlusAccess() {
    return restApi({
      method: "GET",
      url: "/user/access-level",
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  addAccessToBulletinPlus(id) {
    return restApi({
      method: "PATCH",
      url: `/user/${id}/grant-access-level`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }

  revokeAccessToBulletinPlus(id) {
    return restApi({
      method: "PATCH",
      url: `/user/${id}/remove-access-level`,
      headers: {
        Authorization: "Bearer " + session.getAccessToken(),
      },
    });
  }
}

export const UserService = new UserApi();
